import { Component, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-options-dialog',
  imports: [],
  templateUrl: './options-dialog.component.html',
  styleUrl: './options-dialog.component.scss'
})
export class OptionsDialogComponent implements OnDestroy{
  
  id!: string;
  message!: string;
  options!: any[];

  private subject: Subject<any> = new Subject();

  ngOnDestroy(): void {
    this.subject.complete();
  }

  emit(value: any) {
    this.subject.next(value);
  }

  public getSelectedOption() : Observable<any> {
    return this.subject.asObservable();
  }
}
